<p-dialog [(visible)]="display" [modal]="true" [showHeader]="false" [closable]="false" [draggable]="false"
  [style]="{width: '700'}">

  <p class="popup-text-bold">{{ 'Extranet_Renovating_Popup_Title' | translate }}</p>
  <p class="popup-text">{{ 'Extranet_Renovating_Popup_Text' | translate }}</p>

  <div class="grid m-4 mb-2">
    <div class="col-8">
      <p-checkbox [(ngModel)]="dontShowAgain" [binary]="true" inputId="dontShowThisAgain" />
      <label for="dontShowThisAgain" translate>Extranet_Renovating_Popup_Dont_Show_Again</label>
    </div>
    <div class="col-4 text-right">
      <button class="btn bg-blue-link" (click)="onClickButton()" translate>Webbilling_Travel_Popup_Ok</button>
    </div>
  </div>
</p-dialog>